import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-text\"><path d=\"M320.88 320.896h398.224v126.656h-64v-62.656h-270.24v62.656h-64v-126.656zM446.192 696.896h147.552v64h-147.552v-64z\" p-id=\"14435\" /><path d=\"M552 362.672v398.224h-64v-398.24h64z\" p-id=\"14436\" /><path d=\"M112 112h816v816H112V112z m64 64v688h688V176H176z\" p-id=\"14437\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol